var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecruitment2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 80,
    viewBox: "0 0 84 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31754",
    "data-name": "\\uC0AC\\uAC01\\uD615 31754",
    width: 84,
    height: 80,
    transform: "translate(791 4518)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31753",
    "data-name": "\\uC0AC\\uAC01\\uD615 31753",
    width: 80.446,
    height: 78.174,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_674",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 674",
    transform: "translate(-791 -4518)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1229",
    "data-name": "\\uADF8\\uB8F9 1229",
    transform: "translate(792.777 4518.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1228",
    "data-name": "\\uADF8\\uB8F9 1228",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31752",
    "data-name": "\\uC0AC\\uAC01\\uD615 31752",
    width: 73.15,
    height: 8.426,
    rx: 2,
    transform: "translate(3.648 22.186)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_214",
    "data-name": "\\uC120 214",
    x2: 63.266,
    transform: "translate(9.621 64.725)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_215",
    "data-name": "\\uC120 215",
    x2: 39.763,
    transform: "translate(21.372 72.559)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_216",
    "data-name": "\\uC120 216",
    y2: 11.668,
    transform: "translate(6.911 32.153)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_217",
    "data-name": "\\uC120 217",
    y2: 11.668,
    transform: "translate(72.887 32.153)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_793",
    "data-name": "\\uD328\\uC2A4 793",
    d: "M30.309,21.6H13.786a8.115,8.115,0,0,1,8.05-8.177h.424A8.115,8.115,0,0,1,30.309,21.6Z",
    transform: "translate(0.324 0.582)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_794",
    "data-name": "\\uD328\\uC2A4 794",
    d: "M26.261,4.443a3.39,3.39,0,1,1-6.779,0,3.39,3.39,0,1,1,6.779,0Z",
    transform: "translate(-0.711 2.679)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_795",
    "data-name": "\\uD328\\uC2A4 795",
    d: "M52.588,21.6H36.065a8.115,8.115,0,0,1,8.05-8.177h.424A8.115,8.115,0,0,1,52.588,21.6Z",
    transform: "translate(-3.726 0.582)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_796",
    "data-name": "\\uD328\\uC2A4 796",
    d: "M48.54,4.443a3.39,3.39,0,1,1-6.779,0,3.39,3.39,0,1,1,6.779,0Z",
    transform: "translate(-4.761 2.679)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_797",
    "data-name": "\\uD328\\uC2A4 797",
    d: "M73.677,21.6H57.154a8.115,8.115,0,0,1,8.05-8.177h.424A8.115,8.115,0,0,1,73.677,21.6Z",
    transform: "translate(-7.559 0.582)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_798",
    "data-name": "\\uD328\\uC2A4 798",
    d: "M69.628,4.443a3.39,3.39,0,1,1-6.779,0,3.39,3.39,0,1,1,6.779,0Z",
    transform: "translate(-8.594 2.679)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_799",
    "data-name": "\\uD328\\uC2A4 799",
    d: "M56.406,74.782H33.791v-1.6a9.52,9.52,0,0,1,9.444-9.594h3.728a9.52,9.52,0,0,1,9.444,9.594Z",
    transform: "translate(-3.845 -10.72)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_800",
    "data-name": "\\uD328\\uC2A4 800",
    d: "M50.835,52.1A4.64,4.64,0,1,1,46.2,47.383,4.676,4.676,0,0,1,50.835,52.1Z",
    transform: "translate(-4.942 -8.651)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecruitment2);
export default __webpack_public_path__ + "static/media/icon_recruitment_2.6a004c3654aa54f1f63095d3da48a000.svg";
export { ForwardRef as ReactComponent };